import { produce } from 'immer';

import { InitCampaignServiceEditors } from '../../actions/campaignServiceEditor/initCampaignServiceEditors';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function initCampaignServiceEditors(
    state: CampaignServiceEditorState,
    action: InitCampaignServiceEditors
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { payload } = action;

        payload.forEach(({ editorId, service: { serviceId, isMobile } }) => {
            draft[editorId] = {
                serviceId: serviceId,
                isMobile: isMobile,
                isOpen: true,
                errors: []
            };
        });
    });
}
